<template>
	<div>
		<!-- Fondo de marca fijo detrás de todo (ver HyFFondo.vue). -->
		<HyFFondo v-if="fondo" />
		<Header v-if="!hideHeader" />
		<div class="main-content row mx-0">
			<div class="col-12 px-0">
				<slot />
			</div>
		</div>
		<FooterNuevo v-if="!hideFooter" />
	</div>
</template>

<script>
import FooterNuevo from "@/components/Footer/FooterNuevo";
import Header from "@/components/Header/Header";
import HyFFondo from "@/components/Fondo/HyFFondo.vue";

export default {
	components: {
		FooterNuevo,
		Header,
		HyFFondo
	},
    props: {
        showDashboard: {
            type: Boolean,
            default: false
        },
        hideHeader: {
            type: Boolean,
            default: false
        },
        hideFooter: {
            type: Boolean,
            default: false
        },
        // Fondo de marca (todas las rutas salvo `meta: { fondo: false }`).
        fondo: {
            type: Boolean,
            default: true
        }
    }
};
</script>

<style lang="scss" scoped>

.main-content {
    padding-top: $mobile-header-height;
    @media (min-width: $md) {
        padding-top: $desktop-header-height;
    }
}

</style>
